/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid, HFlow } from 'bold-ui'
import { SubmitButton, TextAreaField, TextField } from 'components/form'
import { ProcedimentoOdontoSelectField } from 'components/form/field/select/ProcedimentoOdontoSelectField'
import { FormApi } from 'final-form'
import { TipoParteBucalEnum } from 'graphql/types.generated'
import { Form } from 'react-final-form'
import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, required } from 'util/validation'

import { OutrosFieldModel, trimOutrosObservacao } from './OutrosField'

export interface OutrosFormModel extends Omit<OutrosFieldModel, '_id'> {}

export interface OutrosFormProps {
  editing?: boolean
  cidadaoDataNascimento: LocalDate
  initialValues?: OutrosFieldModel
  onSubmit(values: OutrosFormModel, form: FormApi): void
  onCancel?(): void
}

export const validator = createValidator<OutrosFormModel>({
  local: [required, maxLength(200)],
  procedimentos: [required],
  observacao: [maxLength(400)],
})

const path = metaPath<OutrosFormModel>()

export default function OutrosForm(props: OutrosFormProps) {
  const { editing, cidadaoDataNascimento, initialValues, onSubmit, onCancel } = props

  const handleSubmit = (values: OutrosFormModel, formApi: FormApi) => {
    onSubmit(trimOutrosObservacao(values), formApi)

    setTimeout(() => {
      formApi.reset()
    })
  }

  return (
    <Form<OutrosFormModel>
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validator}
      keepDirtyOnReinitialize={editing}
      render={(formProps) => {
        return (
          <Grid gap={1}>
            <Cell size={6}>
              <TextField name={path.local} label='Local' maxLength={200} required />
            </Cell>

            <Cell size={6}>
              <ProcedimentoOdontoSelectField
                name={path.procedimentos}
                label='Procedimentos (Evolução odontológica)'
                multiple
                dataNascimento={cidadaoDataNascimento}
                tipoParteBucal={TipoParteBucalEnum.OUTRO}
                required
              />
            </Cell>

            <Cell size={12}>
              <TextAreaField
                name={path.observacao}
                label='Observações'
                maxLength={400}
                placeholder='Insira informações adicionais sobre os procedimentos realizados.'
                style={css`
                  resize: none;
                `}
              />
            </Cell>

            <Cell size={12}>
              <HFlow justifyContent='flex-end'>
                {editing && onCancel && (
                  <Button size='small' onClick={onCancel}>
                    Cancelar
                  </Button>
                )}

                <SubmitButton size='small' kind='primary' handleSubmit={formProps.handleSubmit}>
                  {editing ? 'Salvar' : 'Adicionar'}
                </SubmitButton>
              </HFlow>
            </Cell>
          </Grid>
        )
      }}
    />
  )
}
